module.exports = __webpack_public_path__ + "img/person.614325ba.svg";